<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import { roleService } from "../../../../../services/authservice/role.service";
import RowItem from "../../../../../components/roleitemlist";
import i18n from "../../../../../i18n";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Rounding Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
    RowItem
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Rounding template",
      breadCrumb: {},
      roleData: {},
      fullPermissionDataList: {},
      privilegeDataList: {},
      valueName: '',
      valueNameEn: '',
      valueFullPermission: 0,

      valueTest: true,
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);   
    } 

    

  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      roleService.getOne(id)
        .then(response => {

          this.fetchingStats = true;

          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };
            this.roleData = response;
            this.valueName = this.roleData.data.name;
            this.valueNameEn = this.roleData.data.name_en;
            this.valueFullPermission = this.roleData.data.full_permission_id;
          }
          
          this.loadingRolePrivilleges(id);
          this.loadingSettings(response.setting);
        });
    },

    loadingSettings: function(setting) {

      this.fullPermissionDataList = {data: setting.fullpermissionstatuses};
      // this.privilegeDataList = setting.privileges;
      if(this.isAdd) {
        this.valueFullPermission = 2;
      }

      // console.log(JSON.stringify(this.privilegeDataList));
    },

    loadingRolePrivilleges: function(id) {
      roleService.getRolePrivillege(id).then(response => {

          this.privilegeDataList = response;
        });
    },


    submitSave(){
      this.fetchingStats = false;

      let role_privileges = [];

      Object.keys(this.$refs).map(el => {
          if(this.$refs[el][0] !== undefined && 'getValue' in this.$refs[el][0]) {

            let item = (this.$refs[el][0]).getValue();
            if(item) {
              role_privileges.push(item);
            }
          }
        });

      var obj = {
        name: this.valueName,
        name_en: this.valueNameEn,
        full_permission_id: this.valueFullPermission,
        role_privileges
      };

      // console.log(JSON.stringify(obj));
      
      if(this.isAdd) {
        roleService.insert(obj)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "role"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        roleService.update(this.$route.params.id, obj)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "role"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }

    },
    submitCancel(){
      this.$router.push(this.$route.query.redirectFrom || {
        name: "setting-security-user",
        params: {}
      });
    }
  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.security.role.text'),
        href: '/setting/security/role',
      }, {
        text: $t('setting.security.role.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.security.role.new') : $t('setting.security.role.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.security.role.text'),
        href: '/setting/security/role',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.security.role.new') : $t('setting.security.role.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">     

            <div class="row">
              <div class="col-md-3">
                <div class="row">
                  <div class="col-md-12">
                    <Input 
                      :type="'text'"
                      :id="'name'"
                      v-model="valueName"
                      :require="true"
                      :label="'setting.security.role.name'"  />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <Input 
                      :type="'text'"
                      :id="'name_en'"
                      v-model="valueNameEn"
                      :label="'setting.security.role.name-en'"  />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <Select 
                        :text="'label'"
                        :id="'id'"
                        :auto="true"
                        v-model="valueFullPermission"
                        :list="fullPermissionDataList"
                        :label="'setting.security.role.full-permission'"  />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">

                    <div inline class="row gy-2 gx-3 align-items-end">
                      <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-x-circle'" 
                          v-bind:buttonType="'button'"
                          v-bind:variant="'danger'"
                          @click="submitCancel()"
                          v-bind:title="$t('general.cancel')"  />
                      </div>
                      <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-save bx-tada'" 
                          v-bind:buttonType="'button'"
                          @click="submitSave()"
                          v-bind:requesting="tryingToSubmit"
                          v-bind:title="$t('general.save')"  />
                      </div>
                    </div>
      
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div class="row" style="border-bottom: 1px solid #b6b6b6; font-weight: bold;
                      margin-left: 10px;margin-left: 10px; margin-right: 10px; padding-bottom: 10px;">
                  <div class="col-md-6">{{$t('setting.security.permission')}}</div>
                  <div class="col-md-1">{{$t('setting.security.role.all')}}</div>
                  <div class="col-md-1">{{$t('setting.security.role.get')}}</div>
                  <div class="col-md-1">{{$t('setting.security.role.insert')}}</div>
                  <div class="col-md-1">{{$t('setting.security.role.update')}}</div>
                  <div class="col-md-1">{{$t('setting.security.role.delete')}}</div>
                  <div class="col-md-1">{{$t('setting.security.role.export')}}</div>
                </div>

                <RowItem 
                      v-for="(item, index) in privilegeDataList.data" :key="index"
                      :ref="`row_${index}`"
                      :index="index"
                      :item="item" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>
